'use strict';

(function () {
    angular
        .module('crewing')
        .component('trackingFilterCriteriaDisplay', {
            templateUrl: 'tracking/components/tracking-filter-display-component.tpl.html',
            controller: function ($timeout, $scope, TrackingModel) {
                var vm = this;

                vm.$onInit = function () {
                    TrackingModel.regNumberFilterCriteria.subscribe(function (criteria) {
                        vm.filterModel = criteria;
                    });
                };

                vm.onCloseFilterClick = function () {
                    TrackingModel.setRegNumberFilterCriteria([]);
                }
            },
            bindings: {
            }
        });
})
();
